module.exports = __webpack_public_path__ + "img/微信_副本.37678280.png";